import wbSunnyIcon from '../../icons/wbSunnyIcon.svg'
import contrastIcon from '../../icons/contrastIcon.svg'
import highContrastIcon from '../../icons/highContrastIcon.svg'

export default [
  {
    label: 'Dark Contrast',
    key: 'dark-contrast',
    icon: contrastIcon,
  },
  {
    label: 'Light Contrast',
    key: 'light-contrast',
    icon: wbSunnyIcon,
  },
  {
    label: 'High Contrast',
    key: 'high-contrast',
    icon: highContrastIcon,
  },
]
